import React from 'react';
import { useParams } from 'react-router-dom';
import Compiler from './Compiler';
import exampleStories from '../data/exampleStories';

const ExampleStory = () => {
  const { storyId } = useParams();
  const story = exampleStories[storyId];
  
  if (!story) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Story Not Found</h1>
          <p className="text-slate-600">The example story you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }
  
  return (
    <Compiler 
      initialTwee={story.twee}
      pageTitle={story.title}
      isExample={true}
      exampleCategory={story.category}
      exampleDescription={story.description}
    />
  );
};

export default ExampleStory;
